<div class="wrapper wrapper-content mtv-parcels-page row notice-screen">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <playlist-and-notices-list></playlist-and-notices-list>
        </div>
    </div>
</div>

<create-notice-wizard *ngIf="noticesService.isNoticeWizardShow"></create-notice-wizard>
<create-notice-modal *ngIf="noticesService.isNoticeModalShow"></create-notice-modal>
<choose-icon-modal *ngIf="noticesService.isChooseIconModalShow"></choose-icon-modal>
<schedule-notice-modal *ngIf="noticesService.isNoticeScheduleShow"></schedule-notice-modal>
<notice-info-modal *ngIf="noticesService.isNoticeInfoShow"></notice-info-modal>



// WEBPACK FOOTER //
// /app/src/app/views/notices/notices.component.html